import {
    MEDIUM_PLAIN_TEXT_LENGTH,
    SHORT_PLAIN_TEXT_LENGTH,
    SHORT_RICH_TEXT_LENGTH
} from '../../constants/common.constants';
import { DISPLAY_NAME_ERROR_REG_EXP, LINK_REG_EXP } from '../../constants/regex.constants';

export const getShortTextLengthError = (fieldName: string, value: string): string | null => {
    return value?.length > SHORT_PLAIN_TEXT_LENGTH ? `${fieldName} is too long` : null;
};

export const getShortRichTextLengthError = (fieldName: string, value: string): string | null => {
    return value?.length > SHORT_RICH_TEXT_LENGTH ? `${fieldName} is too long` : null;
};

export const getUrlError = (fieldName: string, value: string): string | null => {
    if (value?.length > MEDIUM_PLAIN_TEXT_LENGTH) {
        return `${fieldName} is too long`;
    } else if (value?.length > 0) {
        return value.trim().match(LINK_REG_EXP) ? null : 'Please enter a valid URL beginning with http:// or https://';
    }
    return null;
};

export const isValidAsShortPlainText = (value = '') => value.trim().length <= SHORT_PLAIN_TEXT_LENGTH;
export const isValidAsSpecialCharacters = (value = '') => value.trim().match(DISPLAY_NAME_ERROR_REG_EXP);
